import React, { useEffect, useState } from 'react'
 

import { useMutation, useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { useParams } from 'react-router-dom'

import {  showSalary, updateSalary } from '../../../../MyApi/hr/salary'

import PageHeader from '../../../../Components/UI/PageHeader'
import EditSalary from '../../../../Components/hr/salary/salaryUpdate/AddPayrolls'

import LoadingSpinner from '../../../../Components/UI/spinner'




const SalaryUpdate = () => {
const [salaryName ,setSalaryName]= useState("")
const [amount , setAmount] =useState("")
const [amount_type , setAmount_type] =useState("")
const [companyId ,setCompanyId]= useState("")
const [description, setDescription] = useState("")
const [active ,setActive] = useState(1)
const [type ,setType] =useState("")
const lang = localStorage.getItem("i18nextLng")
const [selectedCodeLang ,setSelectedCodeLang]= useState(lang)
const {id}= useParams()
const {data ,isLoading}= useQuery(["showsalary",id],()=>showSalary(id))
 const mutation = useMutation(["updateSalary",id,selectedCodeLang ], (postData)=>updateSalary(postData ,id ,selectedCodeLang) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
    },
    onError:(error)=>{
        toast.error(`${error.response.data.message}`)
    }
 })
const salaries = data?.data || []

useEffect(()=>{
    setSalaryName(salaries.name)
    setAmount(salaries.amount)
    setAmount_type(salaries.amount_type)
    setDescription(salaries.description)
    setActive(salaries.active)
    setType(salaries.type)
    setCompanyId(salaries.company_id)
},[salaries])
 const handlePostRequest =()=>{
    mutation.mutate({
        name:salaryName,   
        description,
        amount_type,
        amount,
        type,
        active,
        sb_company_id:+companyId,
        lang_code:selectedCodeLang
    })
 }
 const onSelectChange =(e)=>{
    setSelectedCodeLang(e.target.value)
 }

 const isDisabled= ()=>{
    return !(salaryName && amount && amount_type && type && companyId && description )
 }
 if(isLoading){
    return <LoadingSpinner/>
 }
 if(!data){
    return <div>no data avalible</div>
 }


  return ( 

    <div>
        <PageHeader showSelect onSelectChange={onSelectChange} title="Edit Salary" showBack={true} saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
        <EditSalary salaryName={salaryName}   amount={amount} type={type} amount_Type={amount_type}   setSalaryName={setSalaryName}  setAmount={setAmount} companyId={companyId} setCompanyId={setCompanyId} setAmount_type={setAmount_type} setDescription={setDescription} description={description} setActive={setActive} active={active} setType={setType} />
    </div>
  )
}

export default SalaryUpdate